'use client';

import { SEARCH_TYPE } from '@/constants/searchType';
import { IconButton, styled } from '@/primitives';
import AdvancedFilterDialog from '@/components/publicSearch/search/components/AdvancedFilterDialog';
import BasicSearchDialog from '../search/components/BasicSearchDialog';
import { useSearchType } from '@/hooks/publicSearch/useSearchType';
import useSearchStore from '@/publicSearch/store/useSearchStore';

export const StyledSearchIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: '4px',
  border: '0.5px solid',
  borderColor: theme.palette.primary.main,
  background: 'background.paper',
}));

export default function SearchActions() {
  const searchType = useSearchType();
  const { openBasicSearchDialog, setOpenBasicSearchDialog } = useSearchStore();

  if (searchType === SEARCH_TYPE.SALE_CATALOGUES) return null;

  return (
    <>
      <AdvancedFilterDialog />
      <BasicSearchDialog
        open={openBasicSearchDialog}
        onClose={() => setOpenBasicSearchDialog(false)}
      />
    </>
  );
}
